import { Controller } from "@hotwired/stimulus";

// Excel(.xlsx) ダウンロードに、現在の絞り込み・並び替え条件(search[]) を引き継がせる。
// ダウンロードリンクは turbo-frame の外にあり href が更新されないため、クリック時に
// 絞り込みフォーム(filterValue で指定)の入力値（filter + hidden の sort/per）をシリアライズし、
// .xlsx の URL に付与してフル遷移でダウンロードする。
export class ExcelDownloadController extends Controller {
  static values = { url: String, filter: String };

  download(event) {
    event.preventDefault();
    const form = document.querySelector(this.filterValue);
    const query = form ? new URLSearchParams(new FormData(form)).toString() : "";
    window.location.href = query ? `${this.urlValue}?${query}` : this.urlValue;
  }
}
